import React, { useContext } from 'react'
import { Column } from 'primereact/column'
import { LoadingContext } from '../M_Utils'

export const M_Column = ({ header, body, id, key, field, dataType,
    onDrop, onDragEnter, className, style, columnKey, color, frozen,
    secondColor, bodyStyle, alignFrozen, filter, showFilterMenu, filterMatchMode,
    filterPlaceholder }) => {
    const ctx = useContext(LoadingContext)
    color = color ? color : ctx.primaryColor ? ctx.primaryColor : "var(--color-black)"
    secondColor = secondColor ? secondColor : ctx.secondaryColor ? ctx.secondaryColor : "var(--color-black)"
console.log(header,frozen,alignFrozen)
    return (
        <Column
            id={id}
            key={key}
            dataType={dataType}
            field={field}
            header={header}
            body={body ? body : null}
            // className={className}
            columnKey={columnKey}
            style={style}
            onDrop={onDrop}
            onDragEnter={onDragEnter}
            headerStyle={{
                borderBottom: `2px solid ${color}`,
                color: secondColor
            }}
            bodyStyle={bodyStyle}
            fronzen={frozen}
            alignFrozen={alignFrozen}
            filter={filter}
            showFilterMenu={showFilterMenu}
            filterMatchMode={filterMatchMode}
            filterPlaceholder={filterPlaceholder}
        ></Column>
    )
}




